function Loader({ load }) {
  return (
    <>
      {load ? (
        <div class="loader">
          <div class="vertical-center">
            <img
              src={require("../../image/icons/icon.png")}
              class="loadinggif"
            />
          </div>
        </div>
      ) : null}
    </>
  );
}

export default Loader;
